const axios = require('axios');

module.exports.getAppRoutes = new Promise((resolve, reject) => {
    try {
        axios.get('https://us-central1-bige-start.cloudfunctions.net/api/articles').then((data) => {
            // console.log("data.data=> ", data.data.data);
            let output = []
            data.data.data.map(element => element.url).forEach(function (e) {
                output.push({ url: e });
            })
            // console.log(output);
            resolve(output);
        });
        /* console.log('articles.data.data.map(element => element.url) ', articles.data.data.reduce(function (a, b) {
            return { url: a.url };
        })); */
        /* return articles.data.data.reduce(function (a) {
            return { url: a.url };
        }); */


    } catch (err) {
        console.error("error slug ", err);
        reject(err);
        return []
    }
});